import { render, staticRenderFns } from "./QueryClientSchemePlanApplications.vue?vue&type=template&id=516c217e"
import script from "./QueryClientSchemePlanApplications.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryClientSchemePlanApplications.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports